export default __webpack_public_path__ + "static/progectImages-73b677b169cd7f2ebb5c710f39915c54.png";